(() => {
  if (window.MareldWishlist?.shareEnabled) return;
  const SHARE_PREFIX = "#mareld-wishlist=";
  function shareEntryData(items) {
    if (!items.length) throw new Error("Deine Merkliste ist noch leer.");
    if (items.length > 100)
      throw new Error(
        "Die Merkliste ist für einen Teilen-Link zu umfangreich.",
      );
    const rows = [],
      seen = new Set();
    for (const entry of items) {
      const handle = String(entry.handle || ""),
        variantId = String(entry.variantId || "");
      if (
        !/^[a-z0-9-]+$/.test(handle) ||
        (variantId && !/^\d{1,20}$/.test(variantId))
      )
        throw new Error(
          "Ein Eintrag kann noch nicht geteilt werden. Bitte öffne den Artikel und merke ihn erneut.",
        );
      const key = `${handle}:${variantId}`;
      if (!seen.has(key)) {
        rows.push([handle, variantId]);
        seen.add(key);
      }
    }
    return { v: 1, items: rows };
  }
  function readSharedWishlist() {
    const hash = window.location.hash || "";
    if (!hash.startsWith(SHARE_PREFIX)) return null;
    try {
      if (hash.length > 8000) throw new Error("too large");
      const encoded = hash.slice(SHARE_PREFIX.length);
      if (!/^[a-zA-Z0-9_-]+$/.test(encoded))
        throw new Error("invalid encoding");
      const payload = JSON.parse(
        window.atob(encoded.replace(/-/g, "+").replace(/_/g, "/")),
      );
      if (
        payload.v !== 1 ||
        !Array.isArray(payload.items) ||
        !payload.items.length ||
        payload.items.length > 100
      )
        throw new Error("invalid payload");
      const entries = [],
        seen = new Set();
      for (const row of payload.items) {
        if (
          !Array.isArray(row) ||
          row.length !== 2 ||
          typeof row[0] !== "string" ||
          typeof row[1] !== "string" ||
          !/^[a-z0-9-]+$/.test(row[0]) ||
          (row[1] && !/^\d{1,20}$/.test(row[1]))
        )
          throw new Error("invalid entry");
        const key = `${row[0]}:${row[1]}`;
        if (!seen.has(key)) {
          entries.push({
            id: `shared:${row[0]}`,
            handle: row[0],
            variantId: row[1],
          });
          seen.add(key);
        }
      }
      return { entries };
    } catch {
      return {
        entries: [],
        error:
          "Dieser Teilen-Link ist unvollständig oder ungültig. Bitte lass dir einen neuen Link schicken.",
      };
    }
  }
  function createWishlistShareUrl(items) {
    const encoded = window
      .btoa(JSON.stringify(shareEntryData(items)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    const url = `${window.location.origin}${window.location.pathname}${SHARE_PREFIX}${encoded}`;
    if (url.length > 8000)
      throw new Error(
        "Die Merkliste ist für einen Teilen-Link zu umfangreich.",
      );
    return url;
  }
  function shareStatus(section, message) {
    const status = section.querySelector("[data-wishlist-share-status]");
    if (status) status.textContent = message;
  }
  function setupWishlistSharing(section, shared) {
    let toolbar = section.querySelector("[data-wishlist-sharing]");
    if (!toolbar) {
      toolbar = document.createElement("div");
      toolbar.dataset.wishlistSharing = "";
      toolbar.style.margin = "16px 0";
      toolbar.innerHTML = `<div class="flex flex-wrap items-center gap-2">
        <button type="button" class="btn btn--secondary btn--small" data-wishlist-share><span class="btn__text">Teilen</span></button>
        <button type="button" class="btn btn--secondary btn--small" data-wishlist-copy><span class="btn__text">Link kopieren</span></button>
        <button type="button" class="btn btn--primary btn--small" data-wishlist-import hidden disabled><span class="btn__text">In meine Merkliste übernehmen</span></button>
        <button type="button" class="btn btn--secondary btn--small" data-wishlist-own hidden><span class="btn__text">Meine Merkliste</span></button>
      </div><p class="text-subtext" style="font-size:13px;line-height:1.5;margin:10px 0 0;" data-wishlist-share-status role="status" aria-live="polite"></p>
      <input type="text" class="form-control" style="margin-top:8px;width:100%;display:none;" data-wishlist-share-link readonly hidden aria-label="Link zur geteilten Merkliste">`;
      const header = section.querySelector(".mareld-wishlist-page__header");
      if (header) header.after(toolbar);
      else section.prepend(toolbar);
    }
    const heading = section.querySelector(".mareld-wishlist-page__title");
    if (heading) {
      if (section.mareldOwnHeading === undefined)
        section.mareldOwnHeading = heading.textContent;
      heading.textContent = shared
        ? "Geteilte Merkliste"
        : section.mareldOwnHeading;
    }
    const hasItems = (shared ? shared.entries : readWishlist()).length > 0;
    toolbar.querySelector("[data-wishlist-share]").disabled = !hasItems;
    toolbar.querySelector("[data-wishlist-copy]").disabled = !hasItems;
    toolbar.querySelector("[data-wishlist-import]").hidden = !shared;
    toolbar.querySelector("[data-wishlist-import]").disabled = true;
    toolbar.querySelector("[data-wishlist-own]").hidden = !shared;
    toolbar.querySelector("[data-wishlist-own]").style.display = shared
      ? ""
      : "none";
    toolbar.querySelector("[data-wishlist-import]").style.display = shared
      ? ""
      : "none";
    if (shared)
      shareStatus(
        section,
        shared.error ||
          "Du siehst eine geteilte Merkliste. Deine eigene Merkliste bleibt erhalten.",
      );
  }
  async function copyWishlistLink(section, url) {
    try {
      if (!window.navigator?.clipboard?.writeText)
        throw new Error("clipboard unavailable");
      await window.navigator.clipboard.writeText(url);
      shareStatus(section, "Link kopiert. Du kannst ihn jetzt verschicken.");
    } catch {
      const field = section.querySelector("[data-wishlist-share-link]");
      field.value = url;
      field.hidden = false;
      field.style.display = "block";
      field.focus();
      field.select?.();
      shareStatus(section, "Bitte kopiere den Link aus diesem Feld.");
    }
  }
  async function shareWishlist(section, nativeShare) {
    try {
      const shared = readSharedWishlist();
      if (shared?.error) throw new Error(shared.error);
      const url = createWishlistShareUrl(
        shared ? shared.entries : readWishlist(),
      );
      const data = { title: "MARELD Merkliste", url };
      if (
        nativeShare &&
        window.navigator?.share &&
        (!window.navigator.canShare || window.navigator.canShare(data))
      ) {
        try {
          await window.navigator.share(data);
          shareStatus(section, "Merkliste geteilt.");
        } catch (error) {
          if (error.name !== "AbortError") await copyWishlistLink(section, url);
        }
      } else await copyWishlistLink(section, url);
    } catch (error) {
      shareStatus(section, error.message);
    }
  }
  function importSharedWishlist(section) {
    const items = readWishlist();
    let added = 0,
      existing = 0;
    for (const { entry, product } of section.mareldSharedRecords || []) {
      const variant = savedWishlistVariant(product, entry);
      if (entry.variantId && !variant) continue;
      const copy = {
        id: String(product.id),
        handle: product.handle,
        url: product.url || `/products/${product.handle}`,
      };
      if (variant) {
        copy.variantId = String(variant.id);
        copy.variantOptions = Array.from(variant.options || []);
      }
      const key = wishlistEntryKey(copy);
      if (items.some((item) => wishlistEntryKey(item) === key)) {
        existing++;
        continue;
      }
      // Preserve all existing variant entries; a legacy product-only entry can be upgraded.
      const generic = variant
        ? items.findIndex(
            (item) => String(item.id) === copy.id && !item.variantId,
          )
        : -1;
      if (generic >= 0) items[generic] = { ...items[generic], ...copy };
      else items.push(copy);
      added++;
    }
    if (!writeWishlist(items)) {
      shareStatus(
        section,
        "Die Merkliste konnte auf diesem Gerät nicht gespeichert werden.",
      );
      return;
    }
    if (added) notifyChange(items);
    else {
      syncButtons();
      updateWishlistCount(items);
    }
    shareStatus(
      section,
      `${added} Auswahl(en) übernommen${existing ? ` · ${existing} bereits gemerkt` : ""}. Deine bisherigen Einträge bleiben erhalten.`,
    );
  }
  // Variant-aware entries remain compatible with the existing mareldWishlist storage.
  const productRequests = new Map();
  const productJobs = [];
  let activeProductRequests = 0;
  function limitedProductRequest(task) {
    return new Promise((resolve, reject) => {
      productJobs.push({ task, resolve, reject });
      drainProductRequests();
    });
  }
  function drainProductRequests() {
    while (activeProductRequests < 4 && productJobs.length) {
      const job = productJobs.shift();
      activeProductRequests++;
      Promise.resolve()
        .then(job.task)
        .then(job.resolve, job.reject)
        .finally(() => {
          activeProductRequests--;
          drainProductRequests();
        });
    }
  }
  function selectedWishlistVariant(button) {
    if (button.closest("[data-wishlist-card]")) return null;
    const info = button.closest("product-info");
    if (
      info &&
      (!info.dataset.productId ||
        String(info.dataset.productId) === String(button.dataset.productId))
    ) {
      const picker = info.querySelector("variant-selects");
      if (!picker) return null;
      const selected = [];
      picker
        .querySelectorAll(":scope > .product-form__input")
        .forEach((group) => {
          const field =
            group.querySelector(
              'input[type="radio"][data-option-name]:checked',
            ) ||
            Array.from(group.querySelectorAll("select"))
              .map((select) => select.selectedOptions?.[0])
              .find((option) => option?.dataset.optionName);
          if (field) selected.push(field.value);
        });
      const matches = (variant) =>
        variant &&
        variant.options?.length === selected.length &&
        variant.options.every((value, index) => value === selected[index]);
      try {
        const variants = JSON.parse(
          picker.querySelector("[data-variants-cache]")?.textContent || "[]",
        );
        const match = variants.find(matches);
        if (match) return match;
      } catch {}
      try {
        const variant = JSON.parse(
          picker.querySelector("[data-selected-variant]")?.textContent ||
            "null",
        );
        if (matches(variant)) return variant;
      } catch {}
      return null; // Never save the previous variant while a new selection is unresolved.
    }
    try {
      const url = new URL(
        button.dataset.productUrl || "",
        window.location.origin,
      );
      const id = url.searchParams.get("variant");
      if (url.origin === window.location.origin && /^\d+$/.test(id || ""))
        return { id, options: [] };
    } catch {}
    return null;
  }
  function wishlistEntryKey(entry) {
    return `${String(entry.id)}:${String(entry.variantId || "product")}`;
  }
  function savedWishlistEntry(product) {
    return (
      readWishlist().find((item) => String(item.id) === String(product.id)) ||
      {}
    );
  }
  function savedWishlistVariant(product, entry = savedWishlistEntry(product)) {
    return entry.variantId
      ? (product.variants || []).find(
          (variant) => String(variant.id) === String(entry.variantId),
        ) || null
      : null;
  }
  const STORAGE_KEY = "mareldWishlist",
    readWishlist = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        return Array.isArray(stored)
          ? stored.filter((item) => item && typeof item === "object" && item.id)
          : [];
      } catch (error) {
        return (
          console.warn(
            "MARELD Wishlist: Daten konnten nicht gelesen werden.",
            error,
          ),
          []
        );
      }
    },
    writeWishlist = (items) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        return true;
      } catch (error) {
        console.warn(
          "MARELD Wishlist: Daten konnten nicht gespeichert werden.",
          error,
        );
        return false;
      }
    },
    normalizeId = (value) => String(value || ""),
    isSaved = (productId, items = readWishlist()) => {
      const id = normalizeId(productId);
      return items.some((item) => normalizeId(item.id) === id);
    },
    setButtonState = (button, active, selectionChanged = false) => {
      (button.setAttribute("aria-pressed", active ? "true" : "false"),
        button.classList.toggle("is-active", active),
        button.setAttribute(
          "aria-label",
          selectionChanged
            ? "Auswahl auf dem Merkzettel aktualisieren"
            : active
              ? "Vom Merkzettel entfernen"
              : "Zum Merkzettel hinzuf\xFCgen",
        ));
      const label = button.querySelector("[data-wishlist-label]");
      label &&
        (label.textContent = selectionChanged
          ? "Auswahl aktualisieren"
          : active
            ? "Auf dem Merkzettel"
            : "Zum Merkzettel");
    },
    syncButtons = (root = document) => {
      const items = readWishlist();
      root.querySelectorAll("[data-wishlist-button]").forEach((button) => {
        const selected = selectedWishlistVariant(button);
        const key =
          button.dataset.wishlistEntryKey ||
          wishlistEntryKey({
            id: button.dataset.productId,
            variantId: selected?.id,
          });
        setButtonState(
          button,
          items.some((entry) => wishlistEntryKey(entry) === key),
        );
      });
    },
    updateWishlistCount = (items = readWishlist()) => {
      const count = items.length;
      document.querySelectorAll("[data-wishlist-count]").forEach((counter) => {
        if (count <= 0) {
          ((counter.hidden = !0), (counter.textContent = "0"));
          return;
        }
        ((counter.hidden = !1),
          (counter.textContent = count > 99 ? "99+" : String(count)));
      });
    },
    notifyChange = (items) => {
      (updateWishlistCount(items),
        document.dispatchEvent(
          new CustomEvent("mareld:wishlist:changed", {
            detail: { count: items.length, items },
          }),
        ));
    },
    toggleProduct = (button) => {
      const productId = normalizeId(button.dataset.productId);
      if (!productId || button.disabled) return;
      const items = readWishlist();
      const variant = selectedWishlistVariant(button);
      const entry = {
        id: productId,
        handle: button.dataset.productHandle || "",
        url: String(button.dataset.productUrl || "").split("?")[0],
      };
      if (variant) {
        entry.variantId = String(variant.id);
        entry.variantOptions = Array.from(variant.options || []);
      }
      const key = button.dataset.wishlistEntryKey || wishlistEntryKey(entry);
      const existingIndex = items.findIndex(
        (item) => wishlistEntryKey(item) === key,
      );
      if (existingIndex >= 0) items.splice(existingIndex, 1);
      else if (!button.dataset.wishlistEntryKey) {
        // Upgrade a legacy product-only entry on the first explicit selection.
        const generic = variant
          ? items.findIndex(
              (item) => String(item.id) === productId && !item.variantId,
            )
          : -1;
        if (generic >= 0) items[generic] = { ...items[generic], ...entry };
        else items.push(entry);
      } else if (button.dataset.wishlistSharedEntry) {
        try {
          const sharedEntry = JSON.parse(button.dataset.wishlistSharedEntry);
          if (
            String(sharedEntry.id) !== productId ||
            wishlistEntryKey(sharedEntry) !== key
          )
            return;
          items.push(sharedEntry);
        } catch {
          return;
        }
      } else return;
      if (!writeWishlist(items)) return;
      syncButtons();
      notifyChange(items);
    },
    escapeHtml = (value = "") =>
      String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;"),
    money = (cents) => {
      const currency =
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.shop_currency ||
        "EUR";
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency,
      }).format((Number(cents) || 0) / 100);
    },
    getProduct = (handle) => {
      if (!/^[a-z0-9-]+$/.test(String(handle)))
        return Promise.reject(new Error("Invalid product handle"));
      if (productRequests.has(handle)) return productRequests.get(handle);
      const root = window.Shopify?.routes?.root || "/";
      const request = limitedProductRequest(async () => {
        const response = await fetch(
          `${root}products/${encodeURIComponent(handle)}.js`,
          { credentials: "same-origin", cache: "no-store" },
        );
        if (!response.ok)
          throw new Error(`Produkt ${handle} konnte nicht geladen werden.`);
        return response.json();
      }).finally(() => productRequests.delete(handle));
      productRequests.set(handle, request);
      return request;
    },
    getCartAction = (product, entry = savedWishlistEntry(product)) => {
      const available = (product.variants || []).filter(
        (variant) => variant.available === true,
      );
      if (!available.length) return { type: "sold-out", label: "Ausverkauft" };
      if (entry.variantId) {
        const variant = savedWishlistVariant(product, entry);
        if (!variant) return { type: "choose", label: "Auswahl prüfen" };
        if (!variant.available)
          return { type: "choose", label: "Andere Variante wählen" };
        return {
          type: "add",
          label: "In den Warenkorb",
          variantId: variant.id,
        };
      }
      const onlyVariant =
        product.variants?.length === 1 ? product.variants[0] : null;
      if (
        onlyVariant &&
        onlyVariant.title === "Default Title" &&
        onlyVariant.available
      )
        return {
          type: "add",
          label: "In den Warenkorb",
          variantId: onlyVariant.id,
        };
      return { type: "choose", label: "Variante wählen" };
    },
    addVariantToCart = async (button) => {
      const variantId = normalizeId(button.dataset.variantId);
      if (!variantId || button.disabled) return;
      const originalHtml = button.innerHTML;
      ((button.disabled = !0),
        button.classList.add("is-loading"),
        (button.innerHTML =
          '<span class="btn__text">Wird hinzugef\xFCgt \u2026</span>'));
      try {
        const root = window.Shopify?.routes?.root || "/",
          response = await fetch(`${root}cart/add.js`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
            }),
          });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.description ||
              errorData.message ||
              "Produkt konnte nicht in den Warenkorb gelegt werden.",
          );
        }
        (await response.json(),
          (button.innerHTML = '<span class="btn__text">Im Warenkorb</span>'));
        try {
          sessionStorage.setItem("mareldOpenCartDrawerAfterReload", "1");
        } catch (error) {
          console.warn(
            "MARELD Wishlist: Cart-Drawer-Merker konnte nicht gespeichert werden.",
            error,
          );
        }
        window.setTimeout(() => {
          window.location.reload();
        }, 500);
      } catch (error) {
        (console.warn(
          "MARELD Wishlist: Warenkorb konnte nicht aktualisiert werden.",
          error,
        ),
          (button.disabled = !1),
          button.classList.remove("is-loading"),
          (button.innerHTML = originalHtml));
      }
    },
    swatchCache = new Map(),
    getColorOptionIndex = (product) =>
      (product.options || []).findIndex((option) => {
        const name = typeof option == "string" ? option : option?.name || "";
        return ["farbe", "color", "colour"].includes(
          String(name).trim().toLowerCase(),
        );
      }),
    getColorVariants = (product, entry = savedWishlistEntry(product)) => {
      const colorIndex = getColorOptionIndex(product);
      if (colorIndex < 0) return [];
      const saved = savedWishlistVariant(product, entry),
        groups = new Map();
      for (const variant of product.variants || []) {
        const name = variant.options?.[colorIndex];
        if (!name) continue;
        if (!groups.has(name)) groups.set(name, []);
        groups.get(name).push(variant);
      }
      return Array.from(groups, ([name, variants]) => {
        const matching = saved
          ? variants.find((variant) =>
              variant.options.every(
                (value, index) =>
                  index === colorIndex || value === saved.options[index],
              ),
            )
          : null;
        const chosen =
          matching ||
          variants.find((variant) => variant.available) ||
          variants[0];
        const image =
          chosen.featured_image || chosen.featured_media?.preview_image;
        return {
          name: String(name),
          variantId: saved && !matching ? "" : chosen.id,
          available: saved
            ? !!matching?.available
            : variants.some((variant) => variant.available),
          imageUrl:
            typeof image === "string" ? image : image?.src || image?.url || "",
        };
      });
    },
    getProductPageHtml = async (productUrl) => {
      const cleanUrl = String(productUrl || "").split("?")[0];
      if (!cleanUrl) return "";
      if (swatchCache.has(cleanUrl)) return swatchCache.get(cleanUrl);
      const request = fetch(cleanUrl, {
        credentials: "same-origin",
        headers: { Accept: "text/html" },
      })
        .then((response) => {
          if (!response.ok)
            throw new Error(
              `Produktseite konnte nicht geladen werden: ${response.status}`,
            );
          return response.text();
        })
        .catch(
          (error) => (
            console.warn(
              "MARELD Wishlist: Pillar-Farbfelder konnten nicht geladen werden.",
              error,
            ),
            ""
          ),
        );
      return (swatchCache.set(cleanUrl, request), request);
    },
    getSwatchValue = (swatch, doc) => {
      const direct =
        swatch.getAttribute("aria-label") || swatch.getAttribute("title");
      if (direct) return direct.split(" - ").pop().trim();
      const label = swatch.closest("label");
      if (label) {
        const forId = label.getAttribute("for");
        if (forId) {
          const input = doc.getElementById(forId);
          if (input?.value) return String(input.value).trim();
        }
        const labelText = label.querySelector(
          ".reversed-link__text",
        )?.textContent;
        if (labelText) return labelText.trim();
      }
      const tooltip = swatch.querySelector(".tooltip")?.textContent;
      return tooltip ? tooltip.trim() : "";
    },
    extractPillarSwatches = (html, product, entry) => {
      if (!html) return new Map();
      const doc = new DOMParser().parseFromString(html, "text/html"),
        expectedColors = getColorVariants(product, entry),
        expectedKeys = new Set(
          expectedColors.map((color) => color.name.trim().toLowerCase()),
        ),
        selectors = [
          "main .product-form__input--swatch .swatch-color",
          "main .product-form__input--color .swatch-color",
          "main [data-swatch-type] .swatch-color",
          "main variant-selects .swatch-color",
          "main variant-radios .swatch-color",
          "main .swatches .swatch-color",
        ],
        candidates = Array.from(doc.querySelectorAll(selectors.join(","))),
        result = new Map();
      return (
        candidates.forEach((swatch) => {
          const value = getSwatchValue(swatch, doc);
          if (!value) return;
          const key = value.trim().toLowerCase();
          !expectedKeys.has(key) ||
            result.has(key) ||
            result.set(key, {
              style: swatch.getAttribute("style") || "",
              className:
                swatch.getAttribute("class") || "swatch-color block relative",
            });
        }),
        result
      );
    },
    buildPillarSwatches = async (product, card, entry) => {
      const container = card?.querySelector("[data-wishlist-swatches]");
      if (!container) return;
      const colors = getColorVariants(product, entry);
      if (!colors.length) {
        container.remove();
        return;
      }
      const productUrl = product.url || `/products/${product.handle}`,
        html = await getProductPageHtml(productUrl),
        pillarSwatches = extractPillarSwatches(html, product, entry),
        maxSwatches = 4,
        availableSwatches = colors
          .map((color) => {
            const key = color.name.trim().toLowerCase(),
              pillar = pillarSwatches.get(key);
            return pillar ? { color, pillar } : null;
          })
          .filter(Boolean);
      if (!availableSwatches.length) {
        container.remove();
        return;
      }
      const visibleSwatches = availableSwatches.slice(0, maxSwatches),
        hiddenSwatchCount = Math.max(
          availableSwatches.length - visibleSwatches.length,
          0,
        ),
        swatches = visibleSwatches.map(({ color, pillar }) => {
          const url = color.variantId
            ? `${String(productUrl).split("?")[0]}?variant=${encodeURIComponent(color.variantId)}`
            : String(productUrl).split("?")[0];
          return `
          <li
            class="swatch-item${color.available ? "" : " mareld-wishlist-swatch--unavailable"}"
            data-tooltip
          >
            <a
              href="${escapeHtml(url)}"
              class="${escapeHtml(pillar.className)}"
              style="${escapeHtml(pillar.style)}"
              data-wishlist-color
              data-image-url="${escapeHtml(color.imageUrl)}"
              aria-label="${escapeHtml(product.title)} - ${escapeHtml(color.name)}"
              title="${escapeHtml(product.title)} - ${escapeHtml(color.name)}"
            >
              <span class="tooltip pointer-events-none">${escapeHtml(color.name)}</span>
            </a>
          </li>
        `;
        });
      (hiddenSwatchCount > 0 &&
        swatches.push(`
        <li class="swatch-more mareld-wishlist-card__swatch-more">
          <a
            href="${escapeHtml(String(productUrl).split("?")[0])}"
            class="block reversed-link text-sm-extra"
            aria-label="${escapeHtml(hiddenSwatchCount)} weitere Farben anzeigen"
          >
            <span class="reversed-link__text">+${hiddenSwatchCount}</span>
          </a>
        </li>
      `),
        (container.innerHTML = swatches.join("")),
        (container.hidden = !1));
    },
    hydrateWishlistSwatches = async (records, grid) => {
      await Promise.allSettled(
        records.map(({ product, entry }) => {
          const card = grid.querySelector(
            `[data-wishlist-entry-key="${CSS.escape(wishlistEntryKey(entry))}"]`,
          );
          return buildPillarSwatches(product, card, entry);
        }),
      );
    },
    productCardHtml = (
      product,
      entry = savedWishlistEntry(product),
      sharedView = false,
    ) => {
      const saved = savedWishlistVariant(product, entry);
      const baseUrl = String(
        product.url || `/products/${product.handle}`,
      ).split("?")[0];
      const productUrl = saved
        ? `${baseUrl}?variant=${encodeURIComponent(saved.id)}`
        : baseUrl;
      const colorIndex = getColorOptionIndex(product);
      const multipleColors =
        colorIndex >= 0 &&
        new Set(
          (product.variants || []).map(
            (variant) => variant.options?.[colorIndex],
          ),
        ).size > 1;
      const image =
        saved?.featured_image ||
        (saved && multipleColors
          ? ""
          : product.featured_image || product.images?.[0] || "");
      const imageUrl =
        typeof image === "string" ? image : image?.src || image?.url || "";
      const prices = (product.variants || []).map((variant) =>
        Number(variant.price || 0),
      );
      const pricePrefix =
        !saved &&
        prices.length > 1 &&
        Math.min(...prices) !== Math.max(...prices)
          ? "Ab "
          : "";
      const cartAction = getCartAction(product, entry);
      const selection = saved
        ? saved.options.filter((value) => value !== "Default Title").join(" / ")
        : Array.from(entry.variantOptions || []).join(" / ");
      const selectionStatus = entry.variantId
        ? !saved
          ? "Auswahl bitte erneut prüfen"
          : !saved.available
            ? "Diese Auswahl ist ausverkauft"
            : ""
        : "";
      return `
      <article
        class="mareld-wishlist-card"
        data-wishlist-card="${escapeHtml(product.id)}"
        data-wishlist-entry-key="${escapeHtml(wishlistEntryKey(entry))}"
      >

        <div class="mareld-wishlist-card__media">

          <a
            class="mareld-wishlist-card__image-link"
            href="${escapeHtml(productUrl)}"
            aria-label="${escapeHtml(product.title)}"
          >

            ${
              imageUrl
                ? `
                  <img
                    class="mareld-wishlist-card__image"
                    src="${escapeHtml(imageUrl)}"
                    alt="${escapeHtml(product.title)}"
                    loading="lazy"
                  >
                `
                : ""
            }

          </a>


          <button
            type="button"
            class="mareld-wishlist-button"
            data-wishlist-button
            data-product-id="${escapeHtml(product.id)}"
            data-product-handle="${escapeHtml(product.handle)}"
            data-product-url="${escapeHtml(productUrl)}"
            data-wishlist-entry-key="${escapeHtml(wishlistEntryKey(entry))}"
            ${sharedView ? `data-wishlist-shared-entry="${escapeHtml(JSON.stringify({ id: String(product.id), handle: product.handle, url: baseUrl, variantId: entry.variantId || "", variantOptions: saved?.options || [] }))}"` : ""}
            ${sharedView && entry.variantId && !saved ? 'disabled aria-disabled="true"' : ""}
            aria-label="Vom Merkzettel entfernen"
            aria-pressed="true"
          >

            <span
              class="mareld-wishlist-button__icon"
              aria-hidden="true"
            >

              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                focusable="false"
              >

                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
                  fill="currentColor"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />

              </svg>

            </span>

          </button>

        </div>


        <div class="mareld-wishlist-card__info">

          ${
            product.vendor
              ? `
                <p class="mareld-wishlist-card__vendor">
                  ${escapeHtml(product.vendor)}
                </p>
              `
              : ""
          }


          <h2
            class="mareld-wishlist-card__title"
          >

            <a
              href="${escapeHtml(productUrl)}"
            >
              ${escapeHtml(product.title)}
            </a>

          </h2>


          <p
            class="mareld-wishlist-card__price"
          >
            ${pricePrefix}${money(saved ? saved.price : product.price)}
          </p>


          ${selection || selectionStatus ? `<p class="mareld-wishlist-card__selection" style="font-size:13px;line-height:1.5;margin:0 0 10px;">${escapeHtml(selection)}${selection && selectionStatus ? "<br>" : ""}${escapeHtml(selectionStatus)}</p>` : ""}

          <ul
            class="mareld-wishlist-card__swatches product-card__swatches swatches swatches--product-card flex flex-wrap gap-2 items-center justify-start"
            data-wishlist-swatches
            hidden
          ></ul>


          <div class="mareld-wishlist-card__actions">
            ${
              cartAction.type === "add"
                ? `
                  <button
                    type="button"
                    class="btn btn--primary mareld-wishlist-card__cart-button"
                    data-wishlist-add-to-cart
                    data-variant-id="${escapeHtml(cartAction.variantId)}"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </button>
                `
                : ""
            }

            ${
              cartAction.type === "choose"
                ? `
                  <a
                    class="btn btn--secondary mareld-wishlist-card__cart-button"
                    href="${escapeHtml(productUrl)}"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </a>
                `
                : ""
            }

            ${
              cartAction.type === "sold-out"
                ? `
                  <button
                    type="button"
                    class="btn btn--secondary mareld-wishlist-card__cart-button"
                    disabled
                    aria-disabled="true"
                  >
                    <span class="btn__text">${escapeHtml(cartAction.label)}</span>
                  </button>
                `
                : ""
            }
          </div>

        </div>

      </article>
    `;
    },
    renderWishlistPage = async (section) => {
      const shared = readSharedWishlist();
      setupWishlistSharing(section, shared);
      section.mareldSharedRecords = [];
      const renderToken = (section.mareldRenderToken || 0) + 1;
      section.mareldRenderToken = renderToken;
      const grid = section.querySelector("[data-wishlist-grid]"),
        empty = section.querySelector("[data-wishlist-empty]"),
        loading = section.querySelector("[data-wishlist-loading]"),
        items = shared ? shared.entries : readWishlist();
      if (!grid || !empty || !loading) return;
      if (!items.length) {
        ((loading.hidden = !0),
          (grid.hidden = !0),
          (grid.innerHTML = ""),
          (empty.hidden = !1));
        return;
      }
      ((loading.hidden = !1), (grid.hidden = !0), (empty.hidden = !0));
      const products = (
        await Promise.allSettled(
          items
            .filter((item) => item.handle)
            .map(async (entry) => {
              const product = await getProduct(entry.handle);
              return {
                product,
                entry: shared ? { ...entry, id: String(product.id) } : entry,
              };
            }),
        )
      )
        .filter((result) => result.status === "fulfilled")
        .map((result) => result.value);
      if (section.mareldRenderToken !== renderToken || !section.isConnected)
        return;
      if (((loading.hidden = !0), !products.length)) {
        ((grid.hidden = !0), (grid.innerHTML = ""), (empty.hidden = !1));
        return;
      }
      if (shared) {
        section.mareldSharedRecords = products;
        section.querySelector("[data-wishlist-import]").disabled =
          !products.some(
            ({ product, entry }) =>
              !entry.variantId || savedWishlistVariant(product, entry),
          );
        const missing =
          items.length -
          products.length +
          products.filter(
            ({ product, entry }) =>
              entry.variantId && !savedWishlistVariant(product, entry),
          ).length;
        if (missing)
          shareStatus(
            section,
            `${missing} Auswahl(en) sind nicht mehr abrufbar oder müssen erneut geprüft werden. Die übrigen kannst du übernehmen.`,
          );
      }
      ((grid.innerHTML = products
        .map(({ product, entry }) => productCardHtml(product, entry, !!shared))
        .join("")),
        (grid.hidden = !1),
        (empty.hidden = !0),
        syncButtons(grid),
        hydrateWishlistSwatches(products, grid));
    },
    renderAllWishlistPages = () => {
      document
        .querySelectorAll("[data-mareld-wishlist-page]")
        .forEach((section) => renderWishlistPage(section));
    };
  window.addEventListener("hashchange", () => renderAllWishlistPages());
  document.addEventListener("click", (event) => {
    const control = event.target.closest(
      "[data-wishlist-share], [data-wishlist-copy], [data-wishlist-import], [data-wishlist-own]",
    );
    if (!control || control.disabled) return;
    const section = control.closest("[data-mareld-wishlist-page]");
    if (!section) return;
    event.preventDefault();
    if (control.hasAttribute("data-wishlist-own")) {
      window.history.replaceState(
        null,
        "",
        window.location.pathname + (window.location.search || ""),
      );
      renderAllWishlistPages();
    } else if (control.hasAttribute("data-wishlist-import"))
      importSharedWishlist(section);
    else shareWishlist(section, control.hasAttribute("data-wishlist-share"));
  });
  document.addEventListener("mouseover", (event) => {
    const swatch = event.target.closest("[data-wishlist-color]");
    if (
      !swatch ||
      window.matchMedia?.("(hover: none), (pointer: coarse)").matches
    )
      return;
    const card = swatch.closest(".mareld-wishlist-card"),
      image = card?.querySelector(".mareld-wishlist-card__image"),
      imageUrl = swatch.dataset.imageUrl;
    (image && imageUrl && (image.src = imageUrl),
      card?.querySelectorAll(".swatch-item").forEach((item) => {
        item.removeAttribute("aria-selected");
      }),
      swatch.closest(".swatch-item")?.setAttribute("aria-selected", "true"));
  });
  const isTouchDevice = () =>
      window.matchMedia?.("(hover: none), (pointer: coarse)").matches,
    runTouchButtonAnimation = (button, callback) => {
      if (!button || !isTouchDevice()) {
        callback?.();
        return;
      }
      (button.classList.add("is-touch-active"),
        window.setTimeout(() => {
          callback?.();
        }, 260),
        window.setTimeout(() => {
          button.classList.remove("is-touch-active");
        }, 520));
    };
  (document.addEventListener("click", (event) => {
    const actionButton = event.target.closest(
      ".mareld-wishlist-card__cart-button",
    );
    if (actionButton && actionButton.matches("a") && isTouchDevice()) {
      (event.preventDefault(), event.stopPropagation());
      const targetUrl = actionButton.href;
      runTouchButtonAnimation(actionButton, () => {
        window.location.href = targetUrl;
      });
      return;
    }
    const cartButton = event.target.closest("[data-wishlist-add-to-cart]");
    if (cartButton) {
      (event.preventDefault(),
        event.stopPropagation(),
        runTouchButtonAnimation(cartButton, () => {
          addVariantToCart(cartButton);
        }));
      return;
    }
    const button = event.target.closest("[data-wishlist-button]");
    button &&
      (event.preventDefault(), event.stopPropagation(), toggleProduct(button));
  }),
    document.addEventListener("mareld:wishlist:changed", () => {
      (renderAllWishlistPages(), openCartDrawerAfterReload());
    }));
  const openCartDrawerAfterReload = () => {
    let shouldOpen = !1;
    try {
      ((shouldOpen =
        sessionStorage.getItem("mareldOpenCartDrawerAfterReload") === "1"),
        shouldOpen &&
          sessionStorage.removeItem("mareldOpenCartDrawerAfterReload"));
    } catch (error) {
      console.warn(
        "MARELD Wishlist: Cart-Drawer-Merker konnte nicht gelesen werden.",
        error,
      );
    }
    shouldOpen &&
      window.setTimeout(() => {
        const cartButton = document.querySelector(
          '[aria-controls="CartDrawer"], .cart-drawer-button',
        );
        if (cartButton) {
          cartButton.click();
          return;
        }
        const cartDrawer = document.querySelector(
          "#CartDrawer, cart-drawer, [data-cart-drawer]",
        );
        if (cartDrawer) {
          if (typeof cartDrawer.open == "function") {
            cartDrawer.open();
            return;
          }
          cartDrawer.setAttribute("open", "");
        }
      }, 250);
  };
  document.addEventListener("variant:changed", () => syncButtons());
  window.addEventListener("storage", (event) => {
    if (event.key === STORAGE_KEY) {
      syncButtons();
      updateWishlistCount();
      renderAllWishlistPages();
    }
  });
  (document.addEventListener("DOMContentLoaded", () => {
    const items = readWishlist();
    (syncButtons(), updateWishlistCount(items), renderAllWishlistPages());
  }),
    window.addEventListener("pageshow", () => {
      const items = readWishlist();
      (syncButtons(), updateWishlistCount(items), renderAllWishlistPages());
    }),
    document.addEventListener("shopify:section:load", (event) => {
      (syncButtons(event.target),
        updateWishlistCount(readWishlist()),
        (event.target.matches?.("[data-mareld-wishlist-page]") ||
          event.target.querySelector?.("[data-mareld-wishlist-page]")) &&
          renderAllWishlistPages());
    }),
    (window.MareldWishlist = {
      variantAware: true,
      multiVariant: true,
      shareEnabled: true,
      getItems: readWishlist,
      count: () => readWishlist().length,
      contains: (productId, variantId) =>
        variantId === undefined
          ? isSaved(productId)
          : readWishlist().some(
              (entry) =>
                wishlistEntryKey(entry) ===
                wishlistEntryKey({ id: productId, variantId }),
            ),
      sync: syncButtons,
      render: renderAllWishlistPages,
      updateCount: updateWishlistCount,
    }));
})();
